import {closeCurrentDialog, openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {ConfirmUnsavedGeneralChangesDialog} from '../components/ConfirmUnsavedGeneralChangesDialog';
import {useGeneratedDescriptions} from '../contexts/GeneratedDescriptionsContext';

export function useConfirmUnsavedGeneralChangesBeforeOpen() {
  const {isDirtyRef, formSubmitRef} = useGeneratedDescriptions();

  return (openDetail: () => void, dialogTestId: string) => {
    if (!isDirtyRef.current || !formSubmitRef.current) {
      openDetail();
      return;
    }

    openDialog(
      <ConfirmUnsavedGeneralChangesDialog
        onConfirm={async () => {
          const didSave = await formSubmitRef.current?.();
          closeCurrentDialog();
          if (didSave === true) {
            openDetail();
          }
        }}
        onDecline={closeCurrentDialog}
        data-testid={dialogTestId}
      />,
      {
        title: i18n.t('general.notifications.unsavedChanges.title'),
        'data-testid': `${dialogTestId}-dialog`,
      }
    );
  };
}
